"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var JwtModel = exports.default = /*#__PURE__*/function () {
  function JwtModel() {
    (0, _classCallCheck2.default)(this, JwtModel);
  }
  return (0, _createClass2.default)(JwtModel, null, [{
    key: "parseJwt",
    value: function parseJwt(token) {
      if (!token) {
        return null;
      }
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return "%".concat("00".concat(c.charCodeAt(0).toString(16)).slice(-2));
      }).join(''));
      return JSON.parse(jsonPayload);
    }
  }, {
    key: "isUserAssignedToApp",
    value: function isUserAssignedToApp(appName, token) {
      var appIdsWithoutScope = JwtModel.stripEnvModifiers(JwtModel.stripScopeIds(JwtModel.parseAppsFromCiamToken(token)));
      return (appIdsWithoutScope === null || appIdsWithoutScope === void 0 ? void 0 : appIdsWithoutScope.indexOf(appName)) !== -1;
    }
  }, {
    key: "isUserAssignedToScope",
    value: function isUserAssignedToScope(scoepId, token) {
      var scopeIds = JwtModel.getScopeIds(JwtModel.parseAppsFromCiamToken(token));
      return (scopeIds === null || scopeIds === void 0 ? void 0 : scopeIds.indexOf(scoepId)) !== -1;
    }
  }, {
    key: "parseAppsFromCiamToken",
    value: function parseAppsFromCiamToken(token) {
      var _JwtModel$parseJwt, _JwtModel$parseJwt$cu;
      var apIds = (_JwtModel$parseJwt = JwtModel.parseJwt(token)) === null || _JwtModel$parseJwt === void 0 ? void 0 : (_JwtModel$parseJwt$cu = _JwtModel$parseJwt.custom_attributes) === null || _JwtModel$parseJwt$cu === void 0 ? void 0 : _JwtModel$parseJwt$cu.apps;
      return apIds === null || apIds === void 0 ? void 0 : apIds.split(',');
    }
  }, {
    key: "getScopeIds",
    value: function getScopeIds(appIds) {
      return appIds === null || appIds === void 0 ? void 0 : appIds.map(function (x) {
        return x.slice(0, 3);
      });
    }
  }, {
    key: "stripScopeIds",
    value: function stripScopeIds(appIds) {
      return appIds === null || appIds === void 0 ? void 0 : appIds.map(function (x) {
        return x.slice(3);
      });
    }
  }, {
    key: "stripEnvModifiers",
    value: function stripEnvModifiers(appIds) {
      return appIds === null || appIds === void 0 ? void 0 : appIds.map(function (x) {
        return x.slice(0, 3);
      });
    }
  }, {
    key: "getToken",
    value: function getToken(type) {
      return sessionStorage && sessionStorage["".concat(type, "token")];
    }
  }, {
    key: "getRefreshToken",
    value: function getRefreshToken() {
      var _sessionStorage;
      return (_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage.refreshToken;
    }
  }, {
    key: "setToken",
    value: function setToken(value, type) {
      sessionStorage["".concat(type, "token")] = value;
    }
  }, {
    key: "setRefreshToken",
    value: function setRefreshToken(value) {
      sessionStorage.refreshToken = value;
    }
  }]);
}();